import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../components/Configurer";
// import Dashboard from "./profile/Dashboard";
import StagesManager from "../components/StagesManager";
import { checkPermission, checkTranslation, pathMaker, translate } from "../utils/useful";
// import EditProfile from "./profile/EditProfile";
import Cookies from "universal-cookie";
import PageStatusViewer from "../components/PageStatusViewer";
// import AccountType from "./profile/AccountType";
// import ChangePasword from "./profile/ChangePasword";
import AdminDashboard from "./admin/AdminDashboard";
import AdminFormApplet from "./admin/AdminFormApplet";
import AdminSettingsApplet from "./admin/AdminSettingsApplet";
import { adminPages, adminSections } from "../variables/adminPages";
import Collapsible from "react-collapsible";
import Modal from "../components/Modal";
import AdminWidgetsPage from "./admin/AdminWidgetsPage";
import AdminPermission from "./admin/AdminPermission";
import EpisodeMaker from "./admin/episodeMaker";
import AdminTreeApplet from "./admin/AdminTreeApplet";
import AdminSectionFormApplet from "./admin/AdminSectionFormApplet";
import History from "./History";
import Broadcasts from "./Broadcasts";
import PieChart from "../components/PieChart";
import LeadsReport from "./admin/LeadsReport";
import AdminCodeApplet from "./admin/AdminCodeApplet";
import HttpServices from "../utils/Http.services";
import HotLeadsReport from "./admin/HotLeadsReport";
import LeadsStatusReport from "./admin/LeadsStatusReport";
// import { logoutUser } from "../stores/actionsList";


class Applet extends React.Component {

    state = {
        modules: [],
        collapses: {},
        pages: [
            { name: 'Dashboard', key: '', dontShowInDashboard: true },
            { name: 'Edit Profile', icon: 'https://www.flaticon.com/svg/static/icons/svg/2444/2444452.svg', key: 'edit' },
            { name: 'Account type', icon: 'https://www.flaticon.com/svg/static/icons/svg/744/744922.svg', key: 'type' },
            { name: 'Change Password', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'password' },
            { name: 'episodeMaker', icon: 'https://www.flaticon.com/svg/static/icons/svg/3039/3039392.svg', key: 'episodeMaker' }
        ]
    }


    componentDidMount() {
        let accessPages = Object.values(adminPages)

        this.setState({ isLoading: false }, () => {
            this.setState({ modules: accessPages })
        })

        this.props.setHeader({ title: 'شعبه', baseUrl: this.props.baseUrl, sections: accessPages, permissionBaseKey: 'admin' })


        // return
        setTimeout(() => {
            this.checkDefaultTab()
        }, 50);
        // const cookies = new Cookies();
        // let token = cookies.get('admintoken');
        // if (token) {
        //     this.checkDefaultTab()
        //     this.setState({ isLoading: true })
        //     this.waitForId(10)
        // } else {
        //     this.setState({ pageStatus: 401 })
        // }

        // setInterval(() => {
        //     // console.log("HERE")
        //     if(this.configurer){
        //         console.log(this.configurer)
        //         console.log(this.configurer.props.settingsInfo)
        //     }
        // }, 2000);

        // if(this.configurer){
        //     console.log(this.configurer)
        //     console.log(this.configurer.settingsInfo)
        // }
    }


    getAppletFrames = () => {

        let body = {
            _id: this.state.appletId
        }

        HttpServices.request('getApplet', body, (fetchResult, fetchError) => {
            // console.log(fetchResult, fetchError)
            if (fetchError) { return }

            if (fetchResult?.info) {
                this.props.setHeader('title', fetchResult?.info?.name)
            }
            setTimeout(() => {
                this.props.setHeader('applet', fetchResult?.info)

            }, 50);
            this.setState({ applet: fetchResult.info })
        })

    }


    // waitForId = (leftAttempt) => {
    //     if (this.props.user?.info?._id) {

    //         this.setState({ isLoading: false }, () => {
    //             this.checkDefaultTab()
    //             let accessPages = Object.values(adminPages)
    //             this.setState({ modules: accessPages })
    //         })
    //     } else {
    //         setTimeout(() => {
    //             if (leftAttempt != 0) {
    //                 this.waitForId(leftAttempt - 1)
    //             } else {
    //                 // this.props.actions.logoutUser()
    //                 this.setState({ pageStatus: 401 })
    //             }
    //         }, 500);
    //     }
    // }


    componentDidUpdate(prevProps) {
        // let windowPath = this.props.location.pathname.split('/')
        // windowPath = windowPath[windowPath.length - 1]

        // console.log(this.state.oldPath)
        // console.log(this.props.location.pathname)
        // if (this.state.oldPath != this.props.location.pathname) {
        //     this.setState({ oldPath: this.props.location.pathname }, () => {
        //         this.checkDefaultTab()
        //     })
        // }
        if (prevProps.windowData?.path != this.props.windowData?.path) {
            // this.setState({ oldPath: this.props.location.pathname }, () => {
            this.checkDefaultTab()
            // })
        }
    }



    checkDefaultTab() {

        // let def = ''
        let pageType = null
        let pageInfo = null
        let baseUrl = this.props.baseUrl
        let windowData = this.props.windowData
        // console.log("windowData",windowData)
        if (!windowData?.path) {
            return
        }
        // console.log(windowData)
        let appletId = windowData.path[baseUrl.length]
        let def = windowData.path[baseUrl.length + 1] ?? ''



        this.props.setHeader('baseUrl', [...this.props.baseUrl, appletId])

        // console.log(appletId)
        this.setState({ appletId }, () => {
            this.getAppletFrames()
        })

        // console.log(window.location.pathname)
        // let pathname = window.location.pathname.split('/')
        // pathname.forEach((path, index) => {
        //     if (path == 'document') {
        //         def = pathname[index + 1]
        //     }
        // });


        let pageIsValid = false

        Object.values(adminPages).forEach(page => {
            if (page.key.toLowerCase() === def?.toLowerCase()) {
                pageIsValid = true
                pageType = page.pageType

                pageInfo = page
            }
        });
        // console.log("im heare", 'admin.' + (pageInfo?.key ?? pageInfo?._id))
        // console.log(checkPermission('admin.' + (pageInfo?.key ?? pageInfo?._id)))
        // console.log("pageInfo", pageInfo)
        // console.log(pageInfo?.permissionRules)
        // if (!def || def == '' || checkPermission('admin.' + pageInfo?.key) || !pageInfo || !pageInfo.permissionRules || (checkPermission(pageInfo.permissionRules))) {
        // console.log('admin.' + pageInfo?.key, pageInfo)
        if (!def || def == '' || checkPermission('admin.' + (pageInfo.permissionKey ?? pageInfo?.key ?? pageInfo?._id), null, this.state.applet)) {

            if (!def) {
                def = ''
            }
            // console.log(def)
            if (def === '') {
                pageType = ''
                pageIsValid = true
            }
            if (pageIsValid) {
                // this.state.page = page
                this.setState({ oldPath: this.props.location.pathname, pageStatus: 200 }, () => {
                    this.setState({ path: def, }, () => {
                        // console.log("ddddddddddddddddddddddddd", pageType)
                        this.stageManager.changeStage(pageType, () => {
                            window.scrollTo({ top: 0, behavior: 'smooth' })
                        })
                        setTimeout(() => {
                            this.setState({ page: null }, () => {

                                this.setState({ page: pageInfo })
                            })
                        }, 400);
                    })

                    // this.changePage(def)
                    // if (def == '' || !def) {
                    // this.stageManager.changeStage('dashboard')
                    // this.stageManager.changeStage(def)
                    // // this.props.history.push(pathMaker('/profile'))
                    // } else {

                    //     this.stageManager.changeStage(def)

                    // }
                })
            } else {
                this.setState({ pageStatus: 404 })
            }
        } else {
            this.setState({ pageStatus: 401 })
        }

    }



    changePage = (page) => {

        let path = [...this.props.baseUrl, this.state.appletId, page]

        path = pathMaker(path.join('/'))

        this.props.history.push(path)

        if (this.mobileMenuModal) {
            this.mobileMenuModal.hideModal()
        }

    }


    setUser = (data) => {
        this.props.actions.setUser(data, null, true)
    }


    addNotif = (options) => {
        this.props.actions.addNotif(options)
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }


    showMenu() {
        return (
            <div>
                <div className="text-center py-3">
                    <img src="/images/male.png" width="70px" style={{ borderRadius: 100 }} alt="" />
                    <p className="font-bold mt-1">{this.props.user?.info?.name} {this.props.user?.info?.family}</p>
                    {/* <p className="text-small">{translate("Admin")}</p> */}
                </div>

                {/* <div className="mt-2">
                    <div className="mx-2">
                        <button style={{ background: '#F87C56', color: '#fff' }} onClick={() => this.changePage('')} className={"pageSideOption mainPage flexc " + ('' == this.state.path ? "selected" : '')}>
                            <img className="mrd-3" style={{ width: 20, height: 20, }} src="/images/icons/house.png" alt="home" />
                            <p>خانه</p>
                        </button>
                    </div>

                    {Object.values(adminSections).map((prop, index) => {
                        let adminModule = []
                        for (let i = 0; i < this.state.modules.length; i++) {
                            const element = this.state.modules[i];
                            if (element.parent == prop.key && checkPermission("admin" + '.' + element.key)) {
                                adminModule.push(element)
                            }
                        }
                        if (adminModule.length > 0) {

                            return (
                                <div className="mt-2 pb-0" style={{}}>
                                    <div className="mx-2 mb-2">
                                        <button className="flexcb w-100 text-start " style={{ backgroundColor: !this.state.collapses[prop.key] ? '#F87C56' : '#F87C56  ', borderRadius: "10px", padding: '10px' }} onClick={() => this.changeCollapse(prop.key)}>
                                            <div className="flexc">
                                                <img className="mrd-3" style={{ width: 20, height: 20, }} src={prop.img} alt="" />
                                                <p className="w-100" style={{ fontSize: "13px", fontWeight: 400, whiteSpace: 'nowrap', color: '#fff', }}>{checkTranslation(prop.name)}</p>
                                            </div>
                                            <img width={20} className={"translate " + (!this.state.collapses[prop.key] ? '' : 'rotate-180')} src="/images/icons2/chevron.down.svg" />
                                        </button>
                                    </div>

                                    <Collapsible open={!this.state.collapses[prop.key]}>
                                        {this.state.modules.map((cprop, index) => {
                                            if (cprop.parent == prop.key && !cprop.hidePage) {
                                                if (checkPermission("admin" + '.' + cprop.key) || cprop.key == 'messages') {
                                                    return (
                                                        <div className="mx-2">
                                                            <button onClick={() => this.changePage(cprop.key)} key={index} className={"flexc pageSideOption " + ((cprop.key == this.state.path && !this.state.collapses[prop.key]) ? "selected brl" : 'opacity-8')} style={{ padding: '12px 20px' }}>
                                                                <img className="mrd-3" src={cprop.image} style={{ width: 20, height: 20, }} />
                                                                <p className=" " style={{ fontSize: "12px", fontWeight: "400" }} >{checkTranslation(cprop.title)}</p>
                                                            </button>
                                                        </div>
                                                    )
                                                }
                                            }
                                        })}
                                    </Collapsible>

                                </div>
                            )
                        }

                    })}
                </div> */}
                <div className="m-2" style={{ borderTop: '1px solid rgba(7,59,127,0.3)' }}>
                    {this.state.modules.map((cprop, index) => {
                        if (cprop.parent == 'whthoutParent' && !cprop.hidePage) {
                            if (checkPermission("admin" + '.' + cprop.key) || cprop.key == 'messages') {
                                return (
                                    <div className="mx-2">
                                        <button onClick={() => this.changePage(cprop.key)} key={index} className={"flexc pageSideOption " + ((cprop.key == this.state.path) ? "selected brl" : 'opacity-8')} style={{ padding: '12px 20px' }}>
                                            <img className="mrd-3" src={cprop.image} style={{ width: 20, height: 20, }} />
                                            <p className=" " style={{ fontSize: "12px", fontWeight: "400" }} >{checkTranslation(cprop.title)}</p>
                                        </button>
                                    </div>
                                )
                            }
                        }
                    })}
                </div>
            </div>
        )
    }

    navigationBackButton(action) {
        return (
            <div className="flexc mx-2 h-100 d-md-none">
                <button className="p-0 m-0 flexcc h-100" onClick={() => this.mobileMenuModal.showModal()} style={{ backgroundColor: '#f2f6f8dd', color: '#334455', fontWeight: 'bold' }}>
                    <img className=" " src="/images/menu.png" alt="" width="30px" />
                </button>
                {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
            </div>
        )
    }

    informParent = (message) => {
        if (message == 'permissionDenied') {
            this.setState({ pageStatus: 401 })
        }
        if (message == 'notFound') {
            this.setState({ pageStatus: 404 })
        }
    }

    render() {

        let variables = {
            permissionRoot: 'admin.' + (this.state.page?.permissionParent ?? this.state.page?.key),
            applet: this.state.appletId,
            userId:this.props.user?.info._id
        }
        return (

            <Configurer
                settingsInfo={{
                    showFooter: true, showTabBar: true, showHeader: true, headerTitle: "Admin", button: {},
                    titleButtons: [this.navigationBackButton(this.props.lastStage)]

                }}
                title={"Admin"}
                description={"Admin Description"}
                className="p-0 min-full-height w-100"
                ref={el => this.configurer = el}
            >

                <PageStatusViewer status={this.state.pageStatus}>
                    <div className="w-100"  >
                        <div className="row m-0">

                            {/* <div className="col-12 col-sm-12 col-md-3 col-lg-2 pageSide px-0 d-md-block d-none no-scrollbar" style={{ backgroundColor: "#fff", borderRadius: '20px' }}>
                                {this.showMenu()}
                            </div> */}


                            <Modal ref={el => this.mobileMenuModal = el} maxWidth={300}>
                                <div className="pageSide" style={{ backgroundColor: '#fff', borderRadius: 15, padding: '20px 5px 70px 5px' }}>
                                    {this.showMenu()}
                                </div>
                            </Modal>



                            {/* <div className="col-12 col-sm-12 col-md-9 col-lg-10" style={{}}> */}
                            <div className="col-12 p-0 " style={{}}>

                                <StagesManager ref={el => this.stageManager = el} fast={true} >
                                    {/* <AdminWidgetsPage pages={this.state.pages} stage={0} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={translate("CRM panel")} description={translate("List of admin modules")} route={"admin"} /> */}
                                    <AdminDashboard pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} stage={0} windowData={this.props.windowData} user={this.props.user} modules={this.state.modules} stageName={''} changePage={this.changePage} title={translate("Fast Access")} description={translate("List of admin modules")} route={"document"} />
                                    <AdminFormApplet pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'form'} route={"document"} />
                                    <AdminCodeApplet pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'code'} route={"document"} />
                                    <AdminSectionFormApplet pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'AdminSectionFormApplet'} route={"document"} />
                                    <AdminPermission pages={this.state.pages} validSections={['admin']} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'permissions'} route={"document"} />
                                    <EpisodeMaker pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'episodeMaker'} route={"document"} />
                                    <AdminTreeApplet pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'tree'} route={"document"} />
                                    <Broadcasts pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'message'} route={"admin"} />
                                    <History pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'history'} route={"admin"} />
                                    <LeadsReport pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'leadsreport'} route={"document"} />
                                    <HotLeadsReport pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'hotLeadsReport'} route={"document"} />
                                    <LeadsStatusReport pages={this.state.pages} applet={this.state.applet} permissionBaseKey={'admin'} baseUrl={[...this.props.baseUrl, this.state.appletId]} page={this.state.page} stage={1} windowData={this.props.windowData} user={this.props.user} setUser={this.setUser} addNotif={this.addNotif} informParent={this.informParent} history={this.props.history} variables={variables} stageName={'LeadsStatusReport'} route={"document"} />



                                </StagesManager>


                            </div>
                        </div>
                    </div>
                </PageStatusViewer>

            </Configurer>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Applet);
